.content{display:flex;flex-direction:row;align-items:center;justify-content:space-between}
/*# sourceMappingURL=two-column-form.component-MTKYZIU4.css.map */
